import React, { ReactElement, useCallback, useEffect, useState } from "react";
import "./DialogAnimations.css";
import EventBus, { EventBusValues } from "../../utils/EventBus";


export function Dialog() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [content, setContent] = useState<ReactElement | null>(null);
  const [customContent, setCustomContent] = useState<ReactElement | null>(null);

  const onClose = useCallback(() => {
    setIsOpen(false);
    setCustomContent(null);
    setContent(null);
  }, []);

  useEffect(function eventToOpenDialog() {
    EventBus.on(EventBusValues.OpenDialog, (content) => {
      if (content.customContent) {
        setCustomContent(content.element);
      } else {
        setContent(content.element);
      }
      setIsOpen(true);
    });

    return () => {
      EventBus.remove(EventBusValues.OpenDialog, () => setIsOpen(true));
    };
  }, []);

  useEffect(function eventToCloseDialog() {
    EventBus.on(EventBusValues.CloseAllDialogs, onClose);

    return () => {
      EventBus.remove(EventBusValues.CloseAllDialogs, onClose);
    };
  }, [onClose]);

  useEffect(
    function closeOnEscape() {
      const handleEscape = (e: KeyboardEvent) => {
        if (e.key === "Escape") {
          onClose();
        }
      };
      window.addEventListener("keydown", handleEscape);
      return () => {
        window.removeEventListener("keydown", handleEscape);
      };
    },
    [onClose]
  );

  if (!isOpen) {
    return null;
  }
  if (customContent) {
    return customContent;
  }
  return (
    <div>
      {/* Backdrop */}
      <div
        className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 backdrop-blur-[8px] z-[1000] animate-[fadeIn_0.3s_ease-out] items-center align-middle justify-center cursor-default"
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl shadow-[0_20px_40px_rgba(0,0,0,0.15)] z-[1001] max-w-[90vw] max-h-[80dvh] overflow-auto min-w-[320px] sm:min-w-[400px] md:min-w-[600px] outline-none cursor-default animate-[slideIn_0.3s_ease-out] overflow-x-hidden p-4 sm:p-6 md:p-8"
        tabIndex={-1}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            onClose();
          }
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          className="absolute top-4 right-4 bg-none border-none text-2xl cursor-pointer text-gray-600 w-8 h-8 flex items-center justify-center rounded-full transition-all duration-200 ease-in-out hover:bg-gray-100 hover:text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 md:top-3 md:right-3"
          onClick={onClose}
        >
          &#10005;
        </button>
        {content}
      </div>
    </div>
  );
}
